export const SHADOWS = {
  "$shadow-1": "0px 6px 32px rgba(71, 88, 114, 0.1)",
};
